import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import { colors } from '../../app/variables.js'
import $ from 'jquery'
import 'bootstrap'

export default class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'homepage',
      users: this.props.users,
    }
  }

  getMessageAlert() {
    // let currentUserBlockMessages = (_.find(this.state.users.event_users, {user_id: this.props.currentUser.user_id}))?.block_messages
    // only show message alert if block messages not true
    // if(!currentUserBlockMessages){
    let filterFunction = (message) => !message.has_been_read && message.recipient_user_id === this.props.currentUser.user_id
    let unreadMessages = this.props.messages.messages.filter(filterFunction)
    return unreadMessages.length ? unreadMessages.length : null
    // }
  }

  matchingTimeSlot(session) {
    if(session.evaluation_completed){
      let filterFunction = (relatedSessions) => relatedSessions.formatted_display_date === session.formatted_display_date && !relatedSessions.evaluation_completed
      let sessionsInTimeBlock = this.props.sessions.sessions.filter(filterFunction)
      _.each(sessionsInTimeBlock, (matchingSession) => {
        matchingSession.evaluation_taken_in_timeblock = true
      })
    }
  }

  getEvaluationAlert() {
    const surveys = []
    var now = moment().format()
    this.props.sessions.sessions.forEach((session) => {
      this.matchingTimeSlot(session)
      if(!session.itinerary && !session.hidden && window.currentUser.can_take_session_survey) {
        if(!session.evaluation_completed && !session.evaluation_taken_in_timeblock) {
          if(session.day_end_stamp < now &&
            (session.registration_status === 'un_register')) {
            surveys.push(session)
          }
        }
      }
    })
    return surveys.length ? surveys.length : null
  }

  goToLink() {
    $('.navbar-collapse').collapse('hide')
  }

  render() {
    var navigations = []
    if(this.props.currentUser) {
      _.each(this.props.currentUser.app_navigations, (app_navigation, i) => {
        let classes = 'navbar-item'
        if(this.props.activeTab === app_navigation.key) {
          classes += ' active'
        }
        if (app_navigation.key === 'homepage') {
          navigations.push(
            <li
              key={i}
              className={ classes } >
              <Link
                className="nav-link"
                onClick={ this.goToLink }
                to={ '/' + app_navigation.key }>
                <i className={'fa ' + app_navigation.icon}></i>
                { app_navigation.name }
                <span
                  className="data-count"
                  data-count={ this.getMessageAlert() }>
                </span>
              </Link>
            </li>
          )
        } else if(app_navigation.key === 'evaluations') {
          navigations.push(
            <li
              key={i}
              className={ classes } >
              <Link
                className="nav-link"
                onClick={ this.goToLink }
                to={ '/' + app_navigation.key }>
                <i className={'fa ' + app_navigation.icon}></i>
                { app_navigation.name }
                <span
                  className="data-count"
                  data-count={ this.getEvaluationAlert() }>
                </span>
              </Link>
            </li>
          )
        } else {
          navigations.push(
            <li
              key={i}
              className={ classes } >
              <Link
                className="nav-link"
                onClick={ this.goToLink }
                to={ '/' + app_navigation.key }>
                <i className={'fa ' + app_navigation.icon}></i>&nbsp;
                { app_navigation.name }
              </Link>
            </li>
          )
        }
      })
    }
    // const title = window.location.pathname.slice(1).charAt(0).toUpperCase() + window.location.pathname.slice(2);
    return (
      <div>
        <nav className="navbar navbar-light navbar-expand-lg row">
          <a className="navbar-brand-mobile">
            <img
              src='/gartner_c_level_communities_color.svg'
              alt=''
              style={{ maxWidth: '100px' }} />
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <a className="navbar-link navbar-brand">
              <img
                src='/gartner_c_level_communities_color.svg'
                alt=''
                style={{ maxWidth: '110px' }} />
            </a>
            <ul className="navbar-nav">
              { navigations }
              <li className="navbar-item">
                <a
                  className="nav-link"
                  style={{ color: colors.evantaBlue }}
                  onClick={ this.props.logout }>
                  { getLabel('logout') }
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    )
  }
}
